"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _ComponentWithPartials = _interopRequireDefault(require("UIComponents/mixins/ComponentWithPartials"));

var _GoodFiltersAndPage = _interopRequireDefault(require("../constants/GoodFiltersAndPage"));

var _PageLayoutOptions = _interopRequireDefault(require("../constants/PageLayoutOptions"));

var _react = _interopRequireWildcard(require("react"));

var _reactAddonsPureRenderMixin = _interopRequireDefault(require("react-addons-pure-render-mixin"));

var _UIRadioInput = _interopRequireDefault(require("UIComponents/input/UIRadioInput"));

var _UIToggleGroup = _interopRequireDefault(require("UIComponents/input/UIToggleGroup"));

var _langUtils = require("../utils/langUtils");

var PAGE_LAYOUT_OPTIONS = [_PageLayoutOptions.default.ALL, _PageLayoutOptions.default.SINGLE_COLUMN, _PageLayoutOptions.default.TWO_COLUMN, _PageLayoutOptions.default.THREE_COLUMN, _PageLayoutOptions.default.FOUR_COLUMN, _PageLayoutOptions.default.MULTI_ROW];

var _default = _react.default.createClass({
  displayName: "PageLayoutFilter",
  mixins: [_ComponentWithPartials.default, _reactAddonsPureRenderMixin.default],
  propTypes: {
    onGoodFilterChange: _react.PropTypes.func.isRequired,
    pageLayoutFilter: _react.PropTypes.string.isRequired
  },
  getGoodFilterChangeHandlerForPageLayout: function getGoodFilterChangeHandlerForPageLayout(layout) {
    var params = {};
    params[_GoodFiltersAndPage.default.PAGE_LAYOUT] = layout;
    return this.props.onGoodFilterChange(params);
  },
  renderLayoutOption: function renderLayoutOption(layout) {
    return _react.default.createElement(_UIRadioInput.default, {
      checked: this.props.pageLayoutFilter === layout,
      key: layout,
      onChange: this.partial(this.getGoodFilterChangeHandlerForPageLayout, layout),
      name: "pageLayout",
      size: "small",
      text: (0, _langUtils.getPageLayoutOptionText)(layout),
      value: layout
    });
  },
  render: function render() {
    return _react.default.createElement("div", null, _react.default.createElement("div", {
      className: "is--heading-7 m-bottom-1"
    }, (0, _langUtils.getPageLayoutOptionText)('title')), _react.default.createElement("div", {
      className: "integrate-page-layout-filter"
    }, _react.default.createElement(_UIToggleGroup.default, {
      name: "pageLayout"
    }, PAGE_LAYOUT_OPTIONS.map(this.renderLayoutOption))));
  }
});

exports.default = _default;
module.exports = exports.default;